import React, { useState, useRef, useEffect } from "react";

// style
import "video.js/dist/video-js.min.css";
import "videojs-wavesurfer/dist/css/videojs.wavesurfer.css";

// libraries
import videojs from "video.js";

// eslint-disable-next-line
import WaveSurfer from "wavesurfer.js";
// eslint-disable-next-line
import Wavesurfer from "videojs-wavesurfer/dist/videojs.wavesurfer.js";

export default ({
  src,
  autoplay = false,
  controls = true,
  played = () => {},
}) => {
  const videoRef = useRef(null);
  const [player, setPlayer] = useState(null);

  useEffect(() => {
    const vjsPlayer = videojs(
      videoRef.current,
      {
        controls: true,
        controlBar: {
          fullscreenToggle: false,
          remainingTimeDisplay: false,
          progressControl: false,
        },
        fluid: true,
        preload: "none",
        bigPlayButton: true,
        plugins: {
          wavesurfer: {
            backend: "MediaElement",
            displayMilliseconds: false,
            height: "unset",
            waveColor: "white",
            progressColor: "#ccc",
            cursorColor: "#ccc",
            hideScrollbar: true,
          },
        },
      },
      () => {
        setTimeout(() => {
          if (!vjsPlayer.isDisposed()) {
            vjsPlayer.el_.classList.remove("no-pointer-events");
          }
        }, 2000);
      }
    );

    vjsPlayer.on("play", () => {
      played();
    });

    setPlayer(vjsPlayer);

    return () => {
      if (player !== null) {
        player.dispose();
      }
    };

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (player !== null) {
      player.src({ src });
    }

    return () => {
      if (player !== null) {
        player.dispose();
      }
    };
  }, [src, player]);

  return (
    <audio
      ref={videoRef}
      className="video-js vjs-default-skin no-pointer-events"
      playsInline
    />
  );
};
